//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_RENEWAL_API || `${window.location.origin}/renewals`;

export interface ICvRenewalsClient {
	/**
	 * Rate renewal and get payment options
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	rate(policyToken: string, transactionId: string): Promise<RenewalRatingResponse>;
	/**
	 * Update the renewal with the provided changes and then rate and get payment options
	 * @param body (optional) ComplexRateRenewalCommand
	 * @return Payment Options
	 */
	complexRate(body: ComplexRateRenewalCommand | undefined): Promise<RenewalRatingResponse>;
	/**
	 * Create a new version of the renewal and return the risk data along with the new transaction id
	 * @param body (optional) CreateNewRenewalVersionCommand
	 * @return The risk data along with new renewal transaction id
	 */
	createNewRenewalVersion(body: CreateNewRenewalVersionCommand | undefined): Promise<CreateNewRenewalVersionResponse>;
	/**
	 * Reprice the renewal with the provided add-ons
	 * @param body (optional) RepriceRenewalCommand
	 * @return Payment Options
	 */
	reprice(body: RepriceRenewalCommand | undefined): Promise<RenewalRatingResponse>;
	/**
	 * Retrieves the renewal rating - does not rate
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	getRenewalRating(policyToken: string, transactionId: string): Promise<LoadRenewalDetailsResponse>;
	/**
	 * Take up renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpRenewalCommand | undefined): Promise<RenewalTakeupResponse>;
	/**
	 * Reject renewal
	 * @param body (optional) Reject renewal details
	 */
	rejectRenewal(body: RejectRenewalCommand | undefined): Promise<void>;
	/**
	 * Sets the auto-renewal status of the supplied policy. [This DOES NOT set the DoNotRenew status of the policy]
	 * @param body (optional) SetAutoRenewalStatus Command
	 * @return OK
	 */
	setAutoRenewalStatus(body: PolicyAutoRenewalCommand | undefined): Promise<Unit>;
}

export class CvRenewalsClient implements ICvRenewalsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? '';
	}

	/**
	 * Rate renewal and get payment options
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	rate(policyToken: string, transactionId: string, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/Rate/{policyToken}/{transactionId}';
		if (policyToken === undefined || policyToken === null)
			throw new Error("The parameter 'policyToken' must be defined.");
		url_ = url_.replace('{policyToken}', encodeURIComponent('' + policyToken));
		if (transactionId === undefined || transactionId === null)
			throw new Error("The parameter 'transactionId' must be defined.");
		url_ = url_.replace('{transactionId}', encodeURIComponent('' + transactionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRate(_response);
			});
	}

	protected processRate(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('Has claims since renewal invite. Refer.', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Update the renewal with the provided changes and then rate and get payment options
	 * @param body (optional) ComplexRateRenewalCommand
	 * @return Payment Options
	 */
	complexRate(body: ComplexRateRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/ComplexRate';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processComplexRate(_response);
			});
	}

	protected processComplexRate(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('Has claims since renewal invite. Refer.', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Create a new version of the renewal and return the risk data along with the new transaction id
	 * @param body (optional) CreateNewRenewalVersionCommand
	 * @return The risk data along with new renewal transaction id
	 */
	createNewRenewalVersion(
		body: CreateNewRenewalVersionCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CreateNewRenewalVersionResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/CreateNewRenewalVersion';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCreateNewRenewalVersion(_response);
			});
	}

	protected processCreateNewRenewalVersion(response: AxiosResponse): Promise<CreateNewRenewalVersionResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CreateNewRenewalVersionResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CreateNewRenewalVersionResponse>(null as any);
	}

	/**
	 * Reprice the renewal with the provided add-ons
	 * @param body (optional) RepriceRenewalCommand
	 * @return Payment Options
	 */
	reprice(body: RepriceRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/Reprice';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processReprice(_response);
			});
	}

	protected processReprice(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Retrieves the renewal rating - does not rate
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	getRenewalRating(
		policyToken: string,
		transactionId: string,
		cancelToken?: CancelToken,
	): Promise<LoadRenewalDetailsResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/GetRenewalRating/{policyToken}/{transactionId}';
		if (policyToken === undefined || policyToken === null)
			throw new Error("The parameter 'policyToken' must be defined.");
		url_ = url_.replace('{policyToken}', encodeURIComponent('' + policyToken));
		if (transactionId === undefined || transactionId === null)
			throw new Error("The parameter 'transactionId' must be defined.");
		url_ = url_.replace('{transactionId}', encodeURIComponent('' + transactionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetRenewalRating(_response);
			});
	}

	protected processGetRenewalRating(response: AxiosResponse): Promise<LoadRenewalDetailsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<LoadRenewalDetailsResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<LoadRenewalDetailsResponse>(null as any);
	}

	/**
	 * Take up renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalTakeupResponse> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/TakeUp';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUp(_response);
			});
	}

	protected processTakeUp(response: AxiosResponse): Promise<RenewalTakeupResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalTakeupResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalTakeupResponse>(null as any);
	}

	/**
	 * Reject renewal
	 * @param body (optional) Reject renewal details
	 */
	rejectRenewal(body: RejectRenewalCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/RejectRenewal';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRejectRenewal(_response);
			});
	}

	protected processRejectRenewal(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal transaction.', status, _responseText, _headers, result404);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Sets the auto-renewal status of the supplied policy. [This DOES NOT set the DoNotRenew status of the policy]
	 * @param body (optional) SetAutoRenewalStatus Command
	 * @return OK
	 */
	setAutoRenewalStatus(body: PolicyAutoRenewalCommand | undefined, cancelToken?: CancelToken): Promise<Unit> {
		let url_ = this.baseUrl + '/api/v1/CvRenewals/SetAutoRenewalStatus';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSetAutoRenewalStatus(_response);
			});
	}

	protected processSetAutoRenewalStatus(response: AxiosResponse): Promise<Unit> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<Unit>(result200);
		} else if (status === 423) {
			const _responseText = response.data;
			let result423: any = null;
			let resultData423 = _responseText;
			result423 = resultData423;
			return throwException('Locked', status, _responseText, _headers, result423);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<Unit>(null as any);
	}
}

export interface IMockClaimsClient {
	/**
	 * @param body (optional)
	 * @return OK
	 */
	addPolicyClaims(body: MockClaimModel[] | undefined): Promise<void>;
}

export class MockClaimsClient implements IMockClaimsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * @param body (optional)
	 * @return OK
	 */
	addPolicyClaims(body: MockClaimModel[] | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/MockClaims/AddPolicyClaims';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processAddPolicyClaims(_response);
			});
	}

	protected processAddPolicyClaims(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Make payment intent with Stripe via ICE
	 * @param body (optional) Make payment intent details
	 * @return Payment Options
	 */
	makePaymentIntent(body: MakePaymentIntentCommand | undefined): Promise<PaymentIntentResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Make payment intent with Stripe via ICE
	 * @param body (optional) Make payment intent details
	 * @return Payment Options
	 */
	makePaymentIntent(
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PaymentIntentResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/MakePaymentIntent';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakePaymentIntent(_response);
			});
	}

	protected processMakePaymentIntent(response: AxiosResponse): Promise<PaymentIntentResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PaymentIntentResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PaymentIntentResponse>(null as any);
	}
}

export interface IRenewalsClient {
	/**
	 * Rate renewal and get payment options
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	rate(policyToken: string, transactionId: string): Promise<RenewalRatingResponse>;
	/**
	 * Update the renewal with the provided changes and then rate and get payment options
	 * @param body (optional) ComplexRateRenewalCommand
	 * @return Payment Options
	 */
	complexRate(body: ComplexRateRenewalCommand | undefined): Promise<RenewalRatingResponse>;
	/**
	 * Create a new version of the renewal and return the risk data along with the new transaction id
	 * @param body (optional) CreateNewRenewalVersionCommand
	 * @return The risk data along with new renewal transaction id
	 */
	createNewRenewalVersion(body: CreateNewRenewalVersionCommand | undefined): Promise<CreateNewRenewalVersionResponse>;
	/**
	 * Reprice the renewal with the provided add-ons
	 * @param body (optional) RepriceRenewalCommand
	 * @return Payment Options
	 */
	reprice(body: RepriceRenewalCommand | undefined): Promise<RenewalRatingResponse>;
	/**
	 * Retrieves the renewal rating - does not rate
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	getRenewalRating(policyToken: string, transactionId: string): Promise<LoadRenewalDetailsResponse>;
	/**
	 * Take up renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpRenewalCommand | undefined): Promise<RenewalTakeupResponse>;
	/**
	 * Reject renewal
	 * @param body (optional) Reject renewal details
	 */
	rejectRenewal(body: RejectRenewalCommand | undefined): Promise<void>;
	/**
	 * Sets the auto-renewal status of the supplied policy. [This DOES NOT set the DoNotRenew status of the policy]
	 * @param body (optional) SetAutoRenewalStatus Command
	 * @return OK
	 */
	setAutoRenewalStatus(body: PolicyAutoRenewalCommand | undefined): Promise<Unit>;
}

export class RenewalsClient implements IRenewalsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Rate renewal and get payment options
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	rate(policyToken: string, transactionId: string, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/Rate/{policyToken}/{transactionId}';
		if (policyToken === undefined || policyToken === null)
			throw new Error("The parameter 'policyToken' must be defined.");
		url_ = url_.replace('{policyToken}', encodeURIComponent('' + policyToken));
		if (transactionId === undefined || transactionId === null)
			throw new Error("The parameter 'transactionId' must be defined.");
		url_ = url_.replace('{transactionId}', encodeURIComponent('' + transactionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRate(_response);
			});
	}

	protected processRate(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('Has claims since renewal invite. Refer.', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Update the renewal with the provided changes and then rate and get payment options
	 * @param body (optional) ComplexRateRenewalCommand
	 * @return Payment Options
	 */
	complexRate(body: ComplexRateRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/ComplexRate';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processComplexRate(_response);
			});
	}

	protected processComplexRate(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException('Has claims since renewal invite. Refer.', status, _responseText, _headers, result409);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Create a new version of the renewal and return the risk data along with the new transaction id
	 * @param body (optional) CreateNewRenewalVersionCommand
	 * @return The risk data along with new renewal transaction id
	 */
	createNewRenewalVersion(
		body: CreateNewRenewalVersionCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CreateNewRenewalVersionResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/CreateNewRenewalVersion';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCreateNewRenewalVersion(_response);
			});
	}

	protected processCreateNewRenewalVersion(response: AxiosResponse): Promise<CreateNewRenewalVersionResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CreateNewRenewalVersionResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CreateNewRenewalVersionResponse>(null as any);
	}

	/**
	 * Reprice the renewal with the provided add-ons
	 * @param body (optional) RepriceRenewalCommand
	 * @return Payment Options
	 */
	reprice(body: RepriceRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/Reprice';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processReprice(_response);
			});
	}

	protected processReprice(response: AxiosResponse): Promise<RenewalRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalRatingResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalRatingResponse>(null as any);
	}

	/**
	 * Retrieves the renewal rating - does not rate
	 * @param policyToken Policy token
	 * @param transactionId Transaction id
	 * @return Payment Options
	 */
	getRenewalRating(
		policyToken: string,
		transactionId: string,
		cancelToken?: CancelToken,
	): Promise<LoadRenewalDetailsResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/GetRenewalRating/{policyToken}/{transactionId}';
		if (policyToken === undefined || policyToken === null)
			throw new Error("The parameter 'policyToken' must be defined.");
		url_ = url_.replace('{policyToken}', encodeURIComponent('' + policyToken));
		if (transactionId === undefined || transactionId === null)
			throw new Error("The parameter 'transactionId' must be defined.");
		url_ = url_.replace('{transactionId}', encodeURIComponent('' + transactionId));
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetRenewalRating(_response);
			});
	}

	protected processGetRenewalRating(response: AxiosResponse): Promise<LoadRenewalDetailsResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<LoadRenewalDetailsResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<LoadRenewalDetailsResponse>(null as any);
	}

	/**
	 * Take up renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalTakeupResponse> {
		let url_ = this.baseUrl + '/api/v1/Renewals/TakeUp';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUp(_response);
			});
	}

	protected processTakeUp(response: AxiosResponse): Promise<RenewalTakeupResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalTakeupResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalTakeupResponse>(null as any);
	}

	/**
	 * Reject renewal
	 * @param body (optional) Reject renewal details
	 */
	rejectRenewal(body: RejectRenewalCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/Renewals/RejectRenewal';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRejectRenewal(_response);
			});
	}

	protected processRejectRenewal(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal transaction.', status, _responseText, _headers, result404);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Sets the auto-renewal status of the supplied policy. [This DOES NOT set the DoNotRenew status of the policy]
	 * @param body (optional) SetAutoRenewalStatus Command
	 * @return OK
	 */
	setAutoRenewalStatus(body: PolicyAutoRenewalCommand | undefined, cancelToken?: CancelToken): Promise<Unit> {
		let url_ = this.baseUrl + '/api/v1/Renewals/SetAutoRenewalStatus';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSetAutoRenewalStatus(_response);
			});
	}

	protected processSetAutoRenewalStatus(response: AxiosResponse): Promise<Unit> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<Unit>(result200);
		} else if (status === 423) {
			const _responseText = response.data;
			let result423: any = null;
			let resultData423 = _responseText;
			result423 = resultData423;
			return throwException('Locked', status, _responseText, _headers, result423);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<Unit>(null as any);
	}
}

export enum PaymentProvider {
	STRIPE = 'STRIPE',
	BRAINTREE = 'BRAINTREE',
}

export enum Product {
	PRIVATE_CAR = 'PRIVATE_CAR',
	COMMERCIAL_VEHICLE = 'COMMERCIAL_VEHICLE',
	TELEMATICS = 'TELEMATICS',
	TAXI = 'TAXI',
	CARROT = 'CARROT',
	HOUSEHOLD = 'HOUSEHOLD',
}

export interface MakePaymentIntentCommand {
	policyToken: string;
	saveCard: boolean;
	currencyCode: string;
	amount: number;
	billingAddress: Address;
	clientReturnUrl?: string | undefined;
	product: Product;
}

export interface ComplexRateRenewalCommand {
	adjustment: RenewalAdjustment;
	policyToken: string;
	transactionId: string;
}

export interface CreateNewRenewalVersionCommand {
	policyToken: string;
	renewalInviteTransactionId: string;
	changeType: RenewalAdjustmentChangeType[];
}

export interface PolicyAutoRenewalCommand {
	policyToken: string;
	autoRenewal: boolean;
}

export interface RejectRenewalCommand {
	policyToken: string;
	transactionId: string;
}

export interface RepriceRenewalCommand {
	policyToken: string;
	transactionId: string;
	underwrittenOptionId: string;
	addOns: SelectedAddOn[];
}

export interface TakeUpRenewalCommand {
	policyToken: string;
	transactionId: string;
	underwrittenOptionId: string;
	paymentOption: PaymentOption;
	upFrontSettlementDetails?: CardPaymentDetails;
	savedBalanceSettlementDetails?: SavedPaymentMethod;
	newBalanceSettlementDetails?: NewPaymentMethodDetails;
	isFutureStartDate?: boolean;
	startDate?: string;
	existingCardPaymentMethodId?: string | undefined;
	sendPostalDocuments?: boolean;
}

export enum CardVendor {
	Visa = 'Visa',
	Mastercard = 'Mastercard',
	Other = 'Other',
}

export enum RenewalAdjustmentChangeType {
	ChangeVehicle = 'ChangeVehicle',
	ChangeAddress = 'ChangeAddress',
	ChangeDriver = 'ChangeDriver',
	ChangeUsageAndMileage = 'ChangeUsageAndMileage',
}

export interface Address {
	line1: string;
	line2?: string | undefined;
	city: string;
	postalCode: string;
	country: string;
}

export interface CardPaymentDetails {
	paymentId: string;
	authorizationId: string;
}

export interface DirectDebitPaymentSchedule {
	firstPaymentDate: string;
	collectionDay: number;
}

export interface ExistingCardPaymentMethod {
	id: string;
	last4Digits: string;
	vendor: CardVendor;
	isDefault: boolean;
}

export interface NewPaymentMethodDetails {
	sortCode: string;
	accountNumber: string;
	bankName: string;
}

export interface PaymentIntentResponse {
	paymentId: string;
	idempotencyKey: string;
	clientIp: string;
}

export enum PaymentOption {
	PayInFull = 'PayInFull',
	FinanceWithoutDeposit = 'FinanceWithoutDeposit',
	FinanceWithDeposit = 'FinanceWithDeposit',
}

export interface SavedPaymentMethod {
	paymentMethodId: string;
}

export interface SavedPaymentMethodDetails {
	maskedAccountNumber: string;
	bankOrBuildingSociety: string;
	paymentMethodId: string;
}

export interface AddOn {
	underwrittenDataPointId: string;
	addOnCode: string;
	addOnDescription: string;
	annualCost: number;
	monthlyCost: number;
	selected: boolean;
}

export interface SelectedAddOn {
	underwrittenDataPointId: string;
	addOnCode: string;
}

export interface AdjustmentAddress {
	postcode: string;
	line1: string;
	line2?: string | undefined;
	line3?: string | undefined;
	line4?: string | undefined;
	city: string;
	county?: string | undefined;
	country?: string | undefined;
}

export interface DriverDetails {
	dataPointId?: string | undefined;
	relationshipToProposer: string;
	title: string;
	firstName: string;
	lastNames: string;
	dateOfBirth: string;
	maritalStatus: string;
	isResidentFromBirth: boolean;
	ukResidenceSince?: string | undefined;
	employmentType: string;
	occupation?: string | undefined;
	industry?: string | undefined;
	otherOccupation?: string | undefined;
	otherIndustry?: string | undefined;
	isMainDriver: boolean;
	licenceType: string;
	licenceRestrictionsId?: string | undefined;
	licenceNumber?: string | undefined;
	licenceObtained: string;
	hasCriminalConvictions: boolean;
	hasNonMotoringConvictions: boolean;
	hasBeenRefusedCover: boolean;
	accessToOtherVehicles: boolean;
	numberOfVehiclesOwned?: number | undefined;
	numberOfVehiclesAccessTo?: number | undefined;
	phoneNumber?: string | undefined;
	partyType?: string | undefined;
	motoringConvictions?: MotoringConviction[] | undefined;
	motoringClaims?: MotoringClaim[] | undefined;
	licenceRestrictions?: LicenceRestriction[] | undefined;
	employmentStatus?: string | undefined;
	otherEmploymentStatus?: string | undefined;
	otherEmploymentType?: string | undefined;
	driverUsage?: string | undefined;
	badgePassedDate?: string | undefined;
}

export interface MotoringClaim {
	dateOfClaim: string;
	typeOfClaim: string;
	statusOfClaim: string;
	atFault: boolean;
	noClaimsBonusAffected: boolean;
	costOfClaim: number;
}

export interface MotoringConviction {
	dateOfConviction?: string | undefined;
	dateOfOffence: string;
	offenceCode: string;
	wasDisqualified: boolean;
	banStartDate?: string | undefined;
	banEndDate?: string | undefined;
	numberOfPoints?: number | undefined;
	fineAmount?: number | undefined;
	isPending?: boolean | undefined;
}

export interface PolicyDetails {
	policyholder: Policyholder;
	operatingArea?: string | undefined;
	ncbYears?: string | undefined;
	ncdEntitlement?: string | undefined;
	protectedNCD?: boolean | undefined;
}

export interface Policyholder {
	address: AdjustmentAddress;
	isHomeOwner: boolean;
}

export interface RenewalAdjustment {
	vehicleDetails: VehicleDetails;
	policyDetails: PolicyDetails;
	drivers: DriverDetails[];
	voluntaryExcessCode: string;
	ncbProtection?: boolean;
	addOns?: SelectedAddOn[] | undefined;
	updateAddons?: boolean | undefined;
}

export interface Modification {
	modificationCode: string;
	details?: string | undefined;
	value: number;
	isForMedicalReasons: boolean;
	isCurrentInsurerNotified: boolean;
}

export interface SecurityDevice {
	deviceCode: string;
	dateFitted: string;
	fittedBy: string;
}

export interface VehicleDetails {
	abiCode: string;
	abiGroup: number;
	annualMileage: number;
	businessMileage: number;
	bodyType: string;
	registration: string;
	make: string;
	model: string;
	numberOfDoors: string;
	fuelType: string;
	transmission: string;
	grossWeight?: number;
	engineSize: number;
	value: number;
	yearOfManufacture: number;
	isLeftHandDrive?: boolean;
	datePurchased?: string;
	isQPlate?: boolean;
	isImported?: boolean;
	vehicleUse: string;
	ownership: string;
	registeredKeeper: string;
	registrationDate: string;
	countryOfRegistration?: string | undefined;
	numberOfSeats: string;
	vehicleOvernight: string;
	overnightAddress?: AdjustmentAddress;
	modifications?: Modification[] | undefined;
	securityDevices?: SecurityDevice[] | undefined;
	coverDefinitionCode?: string | undefined;
	telematicsDeviceInformation?: string | undefined;
	telematicsBox?: boolean;
	licencingAuthority?: string | undefined;
	operatingArea?: string | undefined;
	businessRadius?: string | undefined;
	hasInternalRacking?: boolean;
	vehicleCarriesDangerousGoods?: boolean;
	vehicleVisitsHazardousSites?: boolean;
}

export interface CoverDetails {
	endorsements: Endorsement[];
	fee: number;
	voluntaryExcess: number;
	compulsoryExcess: number;
	compulsoryExcessCode: string;
	driverExcesses: DriverExcess[];
	coverLevel: string;
	ncbDetails: NCB;
}

export interface CreateNewRenewalVersionResponse {
	newRenewalTransactionId: string;
	vehicleDetails: VehicleDetails;
	policyDetails: PolicyDetails;
	drivers: DriverDetails[];
}

export interface DriverExcess {
	compulsoryAmount: number;
	dataPointId: string;
}

export interface Endorsement {
	name?: string | undefined;
	description?: string | undefined;
}

export interface FinancePlan {
	chargeForCredit: number;
	totalPremium: number;
	unequalInstallmentAmount: number;
	standardInstallmentAmount: number;
	apr: number;
	directDebitPaymentSchedule: DirectDebitPaymentSchedule;
	existingDirectDebitPaymentDay?: number | undefined;
	installmentCount?: number | undefined;
}

export interface FinancePlanWithDeposit {
	depositAmount: number;
	chargeForCredit: number;
	totalPremium: number;
	unequalInstallmentAmount: number;
	standardInstallmentAmount: number;
	apr: number;
	directDebitPaymentSchedule: DirectDebitPaymentSchedule;
	existingDirectDebitPaymentDay?: number | undefined;
	installmentCount?: number | undefined;
}

export interface LoadRenewalDetailsResponse {
	vehicleDetails: VehicleDetails;
	policyDetails: PolicyDetails;
	drivers: DriverDetails[];
	renewalRatingResponse: RenewalRatingResponse;
}

export interface NCB {
	isNCBSelected: boolean;
	amount?: number;
	amountIncludingIpt?: number;
	ncbYears?: string | undefined;
	ncdEntitlement?: string | undefined;
}

export interface RenewalRatingResponse {
	annualPremium: number;
	financePlanWithDeposit?: FinancePlanWithDeposit;
	financePlanWithoutDeposit?: FinancePlan;
	balanceSettlementDetails: SavedPaymentMethodDetails;
	insurancePremiumTaxPercentage: number;
	insurancePremiumTaxAmount: number;
	policyAdministrationFee: number;
	underwrittenOptionId: string;
	addOns: AddOn[];
	readonly costDifferenceForFinanceWithDeposit: number;
	readonly costDifferenceForFinanceWithoutDeposit: number;
	paymentProvider: PaymentProvider;
	hasDeclined?: boolean | undefined;
	coverDetails?: CoverDetails;
	existingCardPaymentMethods?: ExistingCardPaymentMethod[] | undefined;
	drivers?: DriverDetails[] | undefined;
}

export interface LicenceRestriction {
	licenceRestrictionsId?: string | undefined;
}

export interface RenewalTakeupResponse {
	policyReference: string;
}

export interface MockClaimModel {
	policyNumber?: string | undefined;
	dateCreated?: string;
	claimType?: string | undefined;
}

export interface Unit {}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
